import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { IBookingFilterFieldsProps } from "@/app/components/routes/auth_routes/SlotsScreen/BookingFiltersComponent/interface";

const BookingFilterFields: React.FC<IBookingFilterFieldsProps> = ({
  formHook,
  isPageReadonly,
  disableSlotsFilter,
  petSpeciesItems,
  serviceTypeItems,
  l2ServiceItems,
  isHomeServiceFlow,
  isAtHomeReschedule,
  cityItems,
  clinicItems,
  providerItems,
  hideProviders = false,
  setSelectedClinic,
}) => {
  const disableServiceSelection = disableSlotsFilter || isAtHomeReschedule;
  return (
    <>
      {isPageReadonly && (
        <>
          <input type="hidden" {...formHook.register("petSpeciesId")} />
          <SearchableSelectMenu
            onSelectItem={(item) => {
              formHook.setValue("petSpeciesId", item.id);
            }}
            disabled={disableSlotsFilter}
            disableSearch={disableSlotsFilter}
            errorMessages={[{ message: "Pet species is required", type: "required" }]}
            fieldError={formHook.formState.errors.petSpeciesId}
            register={formHook.register("petSpeciesId", {
              required: true,
            })}
            containerClassName="mr-2"
            showDropdownIcon
            showTypedErrors={false}
            placeholder="Pet Species"
            selectItems={petSpeciesItems}
            defaultSelected={petSpeciesItems?.filter((l1s) => l1s.id === formHook.watch("petSpeciesId"))[0]}
            autoComplete="false"
          />
        </>
      )}
      <input type="hidden" {...formHook.register("serviceName")} />
      <SearchableSelectMenu
        onSelectItem={(item) => {
          formHook.setValue("service", item.id);
          formHook.setValue("serviceName", item.title);
          formHook.setValue("subService", "");
          formHook.setValue("subServiceName", "");
          formHook.clearErrors("service");
        }}
        disabled={disableServiceSelection}
        disableSearch={disableServiceSelection}
        errorMessages={[{ message: "Service Type Required", type: "required" }]}
        fieldError={formHook.formState.errors.service}
        register={formHook.register("service", {
          required: true,
        })}
        showDropdownIcon
        containerClassName="w-[250px]"
        showTypedErrors={false}
        placeholder="Service Type"
        selectItems={serviceTypeItems}
        defaultSelected={serviceTypeItems?.filter((l1s) => l1s.id === formHook.watch("service"))[0]}
        autoComplete="false"
      />
      <input type="hidden" {...formHook.register("subServiceName")} />
      <SearchableSelectMenu
        onSelectItem={(item) => {
          formHook.setValue("subService", item.id);
          formHook.setValue("subServiceName", item.title);
          formHook.clearErrors("subService");
        }}
        disabled={disableServiceSelection}
        showTooltips
        disableSearch={disableServiceSelection}
        errorMessages={[{ message: "Sub Service Required", type: "required" }]}
        fieldError={formHook.formState.errors.subService}
        register={formHook.register("subService", {
          required: true,
        })}
        placeholder="Sub Service"
        showDropdownIcon
        showTypedErrors={false}
        containerClassName="ml-2 w-[250px]"
        selectItems={l2ServiceItems}
        defaultSelected={l2ServiceItems?.filter((l1s) => l1s.id === formHook.watch("subService"))[0]}
        autoComplete="false"
      />
      {!isHomeServiceFlow && (
        <>
          <SearchableSelectMenu
            onSelectItem={(item) => {
              formHook.setValue("city", String(item.id));
              formHook.setValue("locationId", null);
              formHook.setValue("lat", null);
              formHook.setValue("long", null);
              setSelectedClinic(null);
            }}
            disabled={disableSlotsFilter}
            disableSearch={disableSlotsFilter}
            errorMessages={[{ message: "Required", type: "required" }]}
            fieldError={formHook.formState.errors.city}
            register={formHook.register("city", { required: !formHook.watch("locationId") })}
            showTypedErrors={false}
            showDropdownIcon
            containerClassName="ml-2 w-[250px]"
            placeholder="City"
            selectItems={cityItems}
            defaultSelected={cityItems?.filter((ci) => String(ci.id) === String(formHook.watch("city")))[0]}
            autoComplete="false"
          />
          <SearchableMultiSelectMenu
            errorMessages={[{ message: "Required", type: "required" }]}
            fieldError={formHook.formState.errors.clinics}
            register={formHook.register("clinics", {
              required: false,
            })}
            disabled={disableSlotsFilter}
            disableSearch={disableSlotsFilter}
            withSelectAll
            selectAllTitle="All Clinics"
            showTooltips={true}
            containerClassName="ml-2 w-[250px]"
            showTypedErrors={false}
            onSelectItem={(items) => {
              const clinicIds = items.map((i) => i.id);
              formHook.setValue("clinics", clinicIds);
            }}
            placeholder="Clinics"
            defaultSelected={clinicItems.filter((c) => formHook.watch("clinics").includes(c.id))}
            selectItems={clinicItems}
          />
          {!hideProviders && (
            <SearchableMultiSelectMenu
              onSelectItem={(items) => {
                const providerIds = items.map((i) => i.id);
                formHook.setValue("providers", providerIds);
              }}
              disabled={disableSlotsFilter}
              withDropDownSearch
              errorMessages={[{ message: "Required", type: "required" }]}
              fieldError={formHook.formState.errors.providers}
              register={formHook.register("providers", {
                required: false,
              })}
              withSelectAll
              showTooltips={true}
              showTypedErrors={false}
              containerClassName="ml-2 w-[250px]"
              placeholder="Providers"
              defaultSelected={providerItems.filter((c) => formHook.watch("providers").includes(c.id))}
              selectItems={providerItems}
            />
          )}
        </>
      )}
    </>
  );
};

export default BookingFilterFields;
